/*
 * @Author: CHY
 * @Date: 2022-12-13 18:59:49
 * @LastEditors: Do not edit
 * @LastEditTime: 2023-08-28 10:39:55
 * @FilePath: \liancan-public-screen-school\src\assets\js\api\api.js
 */
const api = {
    /**
     * 首页接口
     */
    getPurchasePricePage: "api/rabbit-web2/canteenDisplay/getPurchasePricePage", // 食堂餐价公示
    getOpenMealPriceList: "api/rabbit-web2/canteenOpen/getOpenMealPriceList", // 供餐价格公示列表（统缴餐）
    getFoodInformationPage: "api/rabbit-web2/canteenOpen/getFoodInformationPage", // 获取餐价公开列表（自选餐）
    getIncomeExpenditureTotal: "api/rabbit-web2/canteenDisplay/getIncomeExpenditureTotal", // 食堂收支结余公示
    getIllegalTotal: "api/rabbit-web2/canteenDisplay/getIllegalTotal", // 食堂违规预警公示总数
    getIllegalPage: "api/rabbit-web2/canteenDisplay/getIllegalPage", // 食堂违规预警公示（列表）
    getCanteenDisplay: "api/rabbit-web2/canteenDisplay/getDept", // 获取食堂名称

    //2022/12/3
    getRecord: "api/rabbit-web2/canteenDisplay/checkout/record" ,// 收入费用公示
	getShowDivs: 'api/rabbit-web2/canteenDisplay/showDivs', //显示窗体
	getMenuPriceAnnouncement: 'api/rabbit-meal/menuPriceAnnouncement/get', //查询公示备注
	getMenuPriceAnnouncementList: 'api/rabbit-meal/menuPriceAnnouncement/list', //获取统缴餐菜谱、自选餐菜谱    

    getSatisfactionSixMonth: 'api/rabbit-evaluate/evaluate/getSatisfactionSixMonth', // 获取近六月的满意度
    getSatisfactionByDate: 'api/rabbit-evaluate/evaluate/getSatisfactionByDate', //通过日期查询满意度
    getTestingPublicity: 'api/rabbit-liancan2/notice/list', // 检测公示记录
    getFoodInformationList: 'api/rabbit-web2/canteenOpen/getFoodInformationList', // 查询当天各餐次的具体菜品
    getListForYingyangsu: 'api/rabbit-meal/menuPriceAnnouncement/listForYingyangsu', // 营养餐菜谱
    getLiancanPurchasePriceComparisonList: 'api/rabbit-liancan2/liancanPurchasePriceComparison/list', // 采购成本公开

    getDormitoryScreenLoadInfo: 'api/rabbit-liancan/FiveScreensApp/dormitory/loadInfo', // 宿舍管理

    // 营养餐相关(大屏)
    getNutritiousDiningOpenScreenInfo: 'api/rabbit-liancan/nutritiousDiningOpen/screenInfo', // 营养餐价格公示
    getNutritiousDiningProcurementDateDetail: 'api/rabbit-liancan/nutritiousDiningProcurement/screen/dateDetail', // 营养餐采购公示(按日期)
    getNutritiousDiningMenuScreenInfo: 'api/rabbit-liancan/nutritiousDiningMenu/screenInfo', // 营养带量食谱公示
};
export { api };
